import {Injectable} from '@angular/core';

import {ForgotPasswordResponse} from '../../models/user';

import {apiEndpoints} from '../app.constants';
import {Observable} from 'rxjs/Observable';
import {BackendHttpService} from '../core/backend-http.service';

@Injectable()
export class ForgotPasswordService extends BackendHttpService<ForgotPasswordResponse> {

  public forgotPassword(email: string, hostName: string): Observable<ForgotPasswordResponse> {
    const params = JSON.stringify({userEmail: email, hostName: hostName});
    return this.post(apiEndpoints.forgotPassword, params);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/forgot-password.service.ts